/**
 * currentAccount — le compte connecté sur l'appareil, lu sur le magasin de l'app au moment du geste.
 *
 * Ce que lit une file d'envoi qui garde le compte qui confie (`engine/shared/outbox`, `owner`) :
 * l'appareil se partage (un frère, une sœur), et un envoi ne part que sous le compte qui l'a confié.
 * Le magasin est lu à la demande : l'importer au chargement du moteur ferait un cycle avec ses réducteurs.
 */
export function currentAccountId(): number | null {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { store } = require("../../data/redux/storeConfig/store") as {
        store: { getState: () => { data?: { currentUser?: { object?: { id?: number | null } | null } } } }
    }
    return store.getState()?.data?.currentUser?.object?.id ?? null
}
